// frontend/user/src/_lib/upload-speed.ts
//
// 上传速度(EMA 平滑)+ ETA 纯逻辑。store 只存 speedBps 结果;计速状态由 upload-run 持有。
// 设计来源:docs/superpowers/plans/2026-06-07-transfers-persist-and-speed.md 任务 1。

import { formatBytes } from '@dogdisk/shared'

export const EMA_ALPHA = 0.3

export type SpeedTick = { ema: number; bytes: number; ts: number }

// nextSpeedBps 用 EMA 平滑瞬时速率(B/s)。prev=null 为首样本(只立基准,ema=0)。
// Δt<=0(同毫秒重复回调)沿用前 ema,避免除零抖动。
export function nextSpeedBps(prev: SpeedTick | null, bytes: number, ts: number): SpeedTick {
  if (!prev) return { ema: 0, bytes, ts }
  const dtMs = ts - prev.ts
  if (dtMs <= 0) return { ema: prev.ema, bytes, ts }
  const instant = ((bytes - prev.bytes) * 1000) / dtMs
  const ema = EMA_ALPHA * instant + (1 - EMA_ALPHA) * prev.ema
  return { ema, bytes, ts }
}

// etaSeconds 剩余字节 / 速率。速率<=0 或非有限 → null(未知)。
export function etaSeconds(remainingBytes: number, bps: number): number | null {
  if (!Number.isFinite(bps) || bps <= 0) return null
  return remainingBytes / bps
}

// formatEta 把秒数转中文"剩余 X秒 / X分Y秒"。null/非有限 → 空串(UI 不渲染)。
export function formatEta(sec: number | null): string {
  if (sec === null || !Number.isFinite(sec) || sec < 0) return ''
  const s = Math.round(sec)
  if (s < 60) return `剩余 ${s}秒`
  const m = Math.floor(s / 60)
  const rem = s % 60
  return `剩余 ${m}分${rem}秒`
}

// formatSpeed B/s → "1.5 MB/s"。null/0/非有限 → em dash。
export function formatSpeed(bps: number | null | undefined): string {
  if (bps == null || !Number.isFinite(bps) || bps <= 0) return '—'
  return `${formatBytes(bps)}/s`
}
